// DishesList.jsx
import React from 'react';
import KitchenReferenceList from './KitchenReferenceList';

const DishesList = (props) => {
  return <KitchenReferenceList referenceType="dishes" {...props} />;
};

export default DishesList;